<script lang="ts">
  import type { Token } from 'marked';
  import Inline from './Inline.svelte';

  interface Props {
    tokens: Token[] | undefined;
  }
  let { tokens }: Props = $props();
</script>

{#each tokens as token, index (index)}
  {#if token.type === 'text'}
    {token.text}
  {:else if token.type === 'strong'}
    <strong><Inline tokens={token.tokens} /></strong>
  {:else if token.type === 'em'}
    <em><Inline tokens={token.tokens} /></em>
  {:else if token.type === 'br'}
    <br />
  {:else if token.type === 'codespan'}
    <code>{token.text}</code>
  {:else if token.type === 'link'}
    <a href={token.href} rel="nofollow noopener noreferrer" target="_blank">
      <Inline tokens={token.tokens} />
    </a>
  {/if}
{/each}
